import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type ActionSheetSubProps = ComponentProps<'div'>;

export const ActionSheetSub = memo(({ className, ...restOfProps }: ActionSheetSubProps) => {
  return <div className={cn('flex flex-col gap-3', className)} {...restOfProps} />;
});

ActionSheetSub.displayName = 'ActionSheetSub';
